import Input from "../../../components/Input/Input";
import ToolTip from "../../../components/Tooltip/Tooltip";
import { getNestedValue, setNestedValue } from "../../../utils/object";

export function PartialFormSemParar({ configuration, setConfiguration, ...props }) {
   function onChange(field, value) {
      const currentValue = getNestedValue(configuration, field);
      if (currentValue === value) return;
      setConfiguration(setNestedValue({ ...configuration }, field, value));
   }

   return (
      <div className="w-full grid grid-cols-2 gap-2.5">
         <Input
            name="networkMask"
            id="networkMask"
            labelText="Máscara de Rede"
            placeholder="XXX.XXX.XXX.XXX"
            value={configuration?.networkMask}
            onChange={({ target }) => onChange('networkMask', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <Input
            name="ipGateway"
            id="ipGateway"
            labelText="Gateway IP"
            placeholder="XXX.XXX.XXX.XXX"
            value={configuration?.ipGateway}
            onChange={({ target }) => onChange('ipGateway', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <Input
            name="macAddress"
            id="macAddress"
            labelText="Endereço MAC (decimal)"
            placeholder="ex. 0.36.119.87.154.3"
            value={configuration?.macAddress}
            onChange={({ target }) => onChange('macAddress', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <Input
            name="adminPassword"
            id="adminPassword"
            type="password"
            labelText="Senha Admin"
            value={configuration?.adminPassword}
            onChange={({ target }) => onChange('adminPassword', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <Input
            name="eventTimeout"
            id="eventTimeout"
            type="number"
            labelText="Timeout de Evento"
            tooltipVisible={true}
            tooltipText="Eventos registrados após esse tempo em segundos, serão ignorados. (0 = ignorar verificação)"
            value={configuration?.eventTimeout}
            onChange={({ target }) => onChange('eventTimeout', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <Input
            name="ignoreSameTagValueTime"
            type="number"
            id="ignoreSameTagValueTime"
            labelText="Tempo ignora tag de mesmo valor (s)"
            value={configuration?.ignoreSameTagValueTime}
            onChange={({ target }) => onChange('ignoreSameTagValueTime', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <h3 className="bordered col-span-2 muted-md gap-1.5 flex items-center" style={{ marginTop: 10, marginBottom: 5 }}>
            Parâmetros da antena
            <ToolTip
               tooltipVisible={true}
               tooltipText={"Consulte fabricante"}
               className="relative -top-0.5"
            />
         </h3>
         <div className="w-full col-span-2 grid grid-cols-4 gap-2.5">
            <Input
               name="rdpower"
               type="number"
               id="rdpower"
               labelText="RDPOWER"
               value={configuration?.rdpower ?? 2600}
               onChange={({ target }) => onChange('rdpower', target.value)}
               disabled={props.type === "consulta"}
               required={true}
            />
            <Input
               name="tgrdrate"
               id="tgrdrate"
               labelText="TGRDRATE"
               value={configuration?.tgrdrate ?? 'HIGH'}
               onChange={({ target }) => onChange('tgrdrate', target.value)}
               disabled={props.type === "consulta"}
               required={true}
            />
            <Input
               name="ftpa"
               id="ftpa"
               labelText="FTPA"
               value={configuration?.ftpa ?? 'OFF'}
               onChange={({ target }) => onChange('ftpa', target.value)}
               disabled={props.type === "consulta"}
               required={true}
            />
            <Input
               name="hoptbl"
               id="hoptbl"
               labelText="HOPTBL"
               value={configuration?.hoptbl ?? 'HIGH'}
               onChange={({ target }) => onChange('hoptbl', target.value)}
               disabled={props.type === "consulta"}
               required={true}
            />
            <Input
               name="rssilow"
               type="number"
               id="rssilow"
               labelText="RSSILOW"
               value={configuration?.rssilow ?? -99}
               onChange={({ target }) => onChange('rssilow', target.value)}
               disabled={props.type === "consulta"}
               required={true}
            />
            <Input
               name="tmrfon"
               type="number"
               id="tmrfon"
               labelText="TMRFON"
               value={configuration?.tmrfon ?? 100}
               onChange={({ target }) => onChange('tmrfon', target.value)}
               disabled={props.type === "consulta"}
               required={true}
            />
            <Input
               name="rssihigh"
               type="number"
               id="rssihigh"
               labelText="RSSIHIGH"
               value={configuration?.rssihigh ?? -26}
               onChange={({ target }) => onChange('rssihigh', target.value)}
               disabled={props.type === "consulta"}
               required={true}
            />
            <Input
               name="tmrfoff"
               type="number"
               id="tmrfoff"
               labelText="TMRFOFF"
               value={configuration?.tmrfoff ?? '0'}
               onChange={({ target }) => onChange('tmrfoff', target.value)}
               disabled={props.type === "consulta"}
               required={true}
            />
         </div>
      </div>
   );
}